module.exports = __webpack_public_path__ + "img/arrow-down.d53afa42.svg";